import { P2GBox } from '@parcel2go/core-ui';
import { useAnalytics } from '@parcel2go/npm-p2g-app';
import ActionMenuContent from '~/apps/smartsend/components/smartsend/sidepanel/action-menu-content';
import { EventSections } from '~/apps/smartsend/lib/events/EventLogger';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { lazy, Suspense } from 'react';
import { SettingsCache } from '~/lib/consts/settings-cache';
const VipDetails = lazy(() => import('./vip'));

export const NavSidebar = ({ currentPageRoute }: { currentPageRoute: string }) => {
  const { track } = useAnalytics();

  const logEvent = (link: string) => {
    track({
      type: 'smartsend_action_menu_click',
      payload: {
        ...GenerateBaseAnalyticsPayload([EventSections.MyAccount, EventSections.NavigationSidebar]),
        link: link
      }
    });
  };

  return (
    <P2GBox
      sx={(t) => ({
        backgroundColor: 'white',
        height: '100%',
        padding: t.spacing(4, 3),
        border: '1px solid #E0E0E0',
        boxShadow: `10px 0px 2px 0px ${t.palette.grey.A200}`,
        minWidth: '280px'
      })}
    >
      <ActionMenuContent logEvent={logEvent} currentPageRoute={currentPageRoute} showFullMenuStructure={false} />
      {SettingsCache.settings.Features.includes('VipSupport') && (
        <Suspense>
          <VipDetails
            isWidget
            wrapper={(x) => <P2GBox sx={{ px: { xs: 0, sm: 2 }, py: 4, width: '250px' }}>{x}</P2GBox>}
          />
        </Suspense>
      )}
    </P2GBox>
  );
};
